import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Card, Button } from "antd";
import moment from "moment";
import { Translate } from "react-translated";

const virtualGridStyle = {
  width: "52%",
  textAlign: "center",
  borderRadius: "0px",
  overflow: "hidden",
  padding: 0,
};
const internalGridStyle = {
  width: "48%",
  textAlign: "center",
  borderRadius: "0px",
  overflow: "hidden",
};
class OnboardingCircle extends Component {
  state = {
    pendingVirtual: false,
    pendingInternal: false,
  };

  togglePendingVirtual = () => {
    this.setState((prevState) => ({ pendingVirtual: !prevState.pendingVirtual }));
  };

  togglePendingInternal = () => {
    this.setState((prevState) => ({ pendingInternal: !prevState.pendingInternal }));
  };

  renderVirtualFollowUp = (date_url) => {
    const { dashboard ,vonboard ,history} = this.props;

    return this.state.pendingVirtual ? (
      <Card.Grid style={virtualGridStyle}>
         <button style={{background:vonboard === 0? '#efefef': 'transparent',border:'none',cursor:vonboard === 0?'not-allowed':'pointer',width:'100.3%',padding:0,height:'100.3%'}} disabled={vonboard===0}>
         <div
          className="value"
          style={{
            fontWeight: "normal",
            fontSize: 40,
          }}
        >
          <Button style={{background:vonboard === 0? '#efefef': 'transparent',border:'none',cursor:vonboard === 0?'not-allowed':'pointer'}} disabled={vonboard===0} onClick={()=>history.push("/bfiles/virtual-follow-up-incompleted-calls" + date_url)}>
         
            {dashboard.stats.bfile_folow_up_not_completed_count}
         
          </Button>
          
        </div>
        <div className="title" style={{ fontWeight: "bold", fontSize: 16 }}>
          Virtual
        </div>
        <Button
          onClick={this.togglePendingVirtual.bind(this)}
          disabled={vonboard === 0}
          type="link"
          // type="default"
          className="internalVirtualFollowupButton"
          style={{ color: "black" }}
        >
          <Translate text={`Show Due`} />
        </Button>
        </button>
      </Card.Grid>
    ) : (
      <Card.Grid style={virtualGridStyle}>
        <button style={{background:vonboard === 0? '#efefef': 'transparent',border:'none',cursor:vonboard === 0?'not-allowed':'pointer',width:'100.3%',padding:0,height:'100.3%'}} disabled={vonboard===0}>
        <div
          className="value"
          style={{
            fontWeight: "normal",
            fontSize: 40,
          }}
        >
          {dashboard.stats.bfile_folow_up_not_completed_count_due != null &&
          dashboard.stats.bfile_folow_up_not_completed_count_due > 0 ? (
            <button style={{background:vonboard === 0? '#efefef': 'transparent',border:'none',cursor:vonboard === 0?'not-allowed':'pointer', textAlign: "center" }} disabled={vonboard===0}  onClick={()=>history.push("/bfiles/virtual-follow-up-due-calls" + date_url)}
              >
              {dashboard.stats.bfile_folow_up_not_completed_count_due}
            </ button>
          ) : (
            dashboard.stats.bfile_folow_up_not_completed_count_due
          )}
        </div>
        <div className="title" style={{ fontWeight: "bold", fontSize: 16 }}>
          Virtual
        </div>
        <Button
          onClick={this.togglePendingVirtual.bind(this)}
          disabled={vonboard === 0}
          type="link"
          // type="default"
          className="internalVirtualFollowupButton"
          style={{ color: "black" }}
        >
          <Translate text={`Show Upcoming`} />
        </Button>
        </button>
      </Card.Grid>
    );
  };

  renderInternalFollowUp = (date_url) => {
    const { dashboard } = this.props;

    return this.state.pendingInternal ? (
      <Card.Grid style={internalGridStyle}>
        <div className="value">
          <Link to={"/bfiles/pending-onboarding-calls" + date_url}>
            {dashboard.stats.pending_onboarding_calls}
          </Link>
        </div>
        <div className="title">Internal</div>
        <Button
          onClick={this.togglePendingInternal.bind(this)}
          type="link"
          className="internalVirtualFollowupButton"
          style={{ color: "black" }}
        >
          <Translate text={`Show Due`} />
        </Button>
      </Card.Grid>
    ) : (
      <Card.Grid style={internalGridStyle}>
        <div className="value">
          {dashboard.stats.onboarding_calls != null &&
          dashboard.stats.onboarding_calls > 0 ? (
            <Link to={"/bfiles/onboarding-calls" + date_url}>
              {dashboard.stats.onboarding_calls}
            </Link>
          ) : (
            dashboard.stats.onboarding_calls
          )}
        </div>
        <div className="title">Internal</div>
        <Button
          onClick={this.togglePendingInternal.bind(this)}
          type="link"
          className="internalVirtualFollowupButton"
          style={{ color: "black" }}
        >
          <Translate text={`Show Upcoming`} />
        </Button>
      </Card.Grid>
    );
  };
  render() {
    const { dashboard, loading, period, start_date, end_date } = this.props;

    if (typeof dashboard.stats === "undefined") {
      dashboard.stats = {
        // internal
        onboarding_calls: 0,
        pending_onboarding_calls: 0,

        // virtual
        bfile_folow_up_not_completed_count: 0,
        bfile_folow_up_not_completed_count_due: 0,
      };
    }

    let date_url = "";
    if (period === "from_to") {
      date_url =
        "/all/" +
        encodeURIComponent(moment(start_date).format("MM/DD/YYYY")) +
        "/" +
        encodeURIComponent(moment(end_date).format("MM/DD/YYYY"));
    }
    if (period === "all_bfiles") {
      date_url = "?all_bfiles";
    }
    return (
      <div style={{ marginBottom: 20 }}>
        <Card
          title={<div style={{ textAlign: "center" }}>Follow Up Calls</div>}
          className="statsDetails"
          loading={loading}
          bordered={false}
          style={{ height: "177px" }}
        >
          <div className="internalVirtualGrid">
            <div>
              {this.renderVirtualFollowUp(date_url)}
              {this.renderInternalFollowUp(date_url)}
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

export default OnboardingCircle;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/onboarding-circle.js